import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'double'
})
export class DoublePipe implements PipeTransform {
    transform(val: number): string {
        return val >= 0 ? ('0' + val).slice(-2) : val.toString();
    }
}
